export const initialState = {
  user: {},
  userRoles: [],
  users: []
}

export default function(state=initialState, action) {
  const { payload, type } = action

  switch(type) {
    case 'USER_LOAD_SUCCEEDED':
      return {
        ...state,
        user: payload.user
      }
    default:
      return state
  }
}
